var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.satelite.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledActividad },
                model: {
                  value: _vm.formFields.satelite.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.satelite, "value", $$v)
                  },
                  expression: "formFields.satelite.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkHDOP.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledActividad },
                model: {
                  value: _vm.formFields.checkHDOP.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkHDOP, "value", $$v)
                  },
                  expression: "formFields.checkHDOP.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkLongYLat.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledActividad },
                model: {
                  value: _vm.formFields.checkLongYLat.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkLongYLat, "value", $$v)
                  },
                  expression: "formFields.checkLongYLat.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkDatoValido.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledActividad },
                model: {
                  value: _vm.formFields.checkDatoValido.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkDatoValido, "value", $$v)
                  },
                  expression: "formFields.checkDatoValido.value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { md6: "" } },
            [
              _c("BuscadorOperacionCrud", {
                attrs: {
                  filter:
                    _vm.gridApi && _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c(
            "v-flex",
            [
              _vm.accion === 3
                ? _c("MantenedorGridVerDetalle", {
                    attrs: {
                      "grid-options": _vm.computedGridOptions,
                      "row-data": _vm.tipoActividad
                    }
                  })
                : _c("AsociacionGrid", {
                    attrs: {
                      "grid-options": _vm.computedGridOptions,
                      esEditar: _vm.accion === 2 ? true : false
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }